/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module MatchModule
 */
import {
    Component,
    Input,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service';

import {
    TlsFingerprintMatchConfigItem,
} from 'ajs/modules/match/factories/tls-fingerprint-match.config-item.factory';

import * as l10n from './tls-fingerprint-match-readonly.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component to show readonly information for TLS Fingerprint Match.
 * @author Sarthak Kapoor
 */
@Component({
    selector: 'tls-fingerprint-match-readonly',
    templateUrl: './tls-fingerprint-match-readonly.component.html',
})
export class TlsFingerprintMatchReadonlyComponent {
    /**
     * TLS Fingerprint Match Config Item object.
     */
    @Input()
    public editable: TlsFingerprintMatchConfigItem;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Return text label for selected match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.match_operation,
        );
    }

    /**
     * Return the list of all the configured tls fingeprints.
     */
    public get tlsFingerprints(): string[] {
        return this.editable.config.fingerprints?.length ?
            [...this.editable.config.fingerprints] :
            [...this.editable.stringGroupRefNames];
    }

    /**
     * Callback to ngFor-track by.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
